import { lazy, Suspense, type ReactNode } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { ROUTES } from "@/constants/routes";

const ServiceCentersPage = lazy(
  () => import("@/pages/ServiceCentersPage/ServiceCentersPage"),
);
const ServiceCenterDetailPage = lazy(
  () => import("@/pages/ServiceCenterDetailPage/ServiceCenterDetailPage"),
);
const ClientsPage = lazy(() => import("@/pages/ClientsPage/ClientsPage"));
const ClientDetailPage = lazy(
  () => import("@/pages/ClientDetailPage/ClientDetailPage"),
);
const PushCampaignsPage = lazy(
  () => import("@/pages/PushCampaigns/PushCampaignsPage"),
);
const PushCampaignEditorPage = lazy(
  () => import("@/pages/PushCampaigns/PushCampaignEditorPage"),
);
const PushCampaignDetailPage = lazy(
  () => import("@/pages/PushCampaigns/PushCampaignDetailPage"),
);
const HelpPage = lazy(() => import("@/pages/HelpPage/HelpPage"));
const HelpSettingsPage = lazy(
  () => import("@/pages/HelpSettingsPage/HelpSettingsPage"),
);
const DiscountsPage = lazy(() => import("@/pages/DiscountsPage/DiscountsPage"));
const DiscountFormPage = lazy(
  () => import("@/pages/DiscountsPage/DiscountFormPage"),
);
const DiscountUsagesPage = lazy(
  () => import("@/pages/DiscountsPage/DiscountUsagesPage"),
);
const BusinessHomePage = lazy(
  () => import("@/pages/BusinessAccount/BusinessHomePage"),
);
const BusinessCarsPage = lazy(
  () => import("@/pages/BusinessAccount/BusinessCarsPage"),
);
const BusinessStatsPage = lazy(
  () => import("@/pages/BusinessAccount/BusinessStatsPage"),
);
const BusinessOrdersPage = lazy(
  () => import("@/pages/BusinessAccount/BusinessOrdersPage"),
);
const BusinessDocumentsPage = lazy(
  () => import("@/pages/BusinessAccount/BusinessDocumentsPage"),
);

const page = (element: ReactNode) => (
  <Suspense fallback={null}>{element}</Suspense>
);

const AppRouter = () => {
  return (
    <Routes>
      <Route
        path="/"
        element={<Navigate to={ROUTES.SERVICE_CENTERS} replace />}
      />
      <Route
        path={ROUTES.SERVICE_CENTERS}
        element={page(<ServiceCentersPage />)}
      />
      <Route
        path={ROUTES.SERVICE_CENTER_DETAIL}
        element={page(<ServiceCenterDetailPage />)}
      />
      <Route path={ROUTES.CLIENTS} element={page(<ClientsPage />)} />
      <Route
        path={ROUTES.CLIENT_DETAIL}
        element={page(<ClientDetailPage />)}
      />
      <Route
        path={ROUTES.PUSH_CAMPAIGNS}
        element={page(<PushCampaignsPage />)}
      />
      <Route
        path={ROUTES.PUSH_CAMPAIGN_NEW}
        element={page(<PushCampaignEditorPage />)}
      />
      <Route
        path={ROUTES.PUSH_CAMPAIGN_EDIT}
        element={page(<PushCampaignEditorPage />)}
      />
      <Route
        path={ROUTES.PUSH_CAMPAIGN_DETAIL}
        element={page(<PushCampaignDetailPage />)}
      />
      <Route
        path={ROUTES.HELP_SETTINGS}
        element={page(<HelpSettingsPage />)}
      />
      <Route path={ROUTES.HELP} element={page(<HelpPage />)} />
      <Route path={ROUTES.DISCOUNTS} element={page(<DiscountsPage />)} />
      <Route path={ROUTES.DISCOUNT_NEW} element={page(<DiscountFormPage />)} />
      <Route
        path={ROUTES.DISCOUNT_USAGES}
        element={page(<DiscountUsagesPage />)}
      />
      <Route
        path={ROUTES.DISCOUNT_DETAIL}
        element={page(<DiscountFormPage />)}
      />
      <Route path={ROUTES.BUSINESS_HOME} element={page(<BusinessHomePage />)} />
      <Route path={ROUTES.BUSINESS_CARS} element={page(<BusinessCarsPage />)} />
      <Route
        path={ROUTES.BUSINESS_ANALYTICS}
        element={page(<BusinessStatsPage />)}
      />
      <Route path={ROUTES.BUSINESS_ORDERS} element={page(<BusinessOrdersPage />)} />
      <Route
        path={ROUTES.BUSINESS_DOCS}
        element={page(<BusinessDocumentsPage />)}
      />
      <Route path="*" element={<Navigate to={ROUTES.SERVICE_CENTERS} replace />} />
    </Routes>
  );
};

export default AppRouter;
